<template>
    <div class="item" :class="{ 'active': isActive }">
        <div class="item-icon">
            <span class="ogc-icon-font" :class="iconClass"></span>
        </div>
        <div class="item-info">
            <p class="strong">{{ title }}</p>
            <p>{{ subTitle }}</p>
        </div>
        <div class="buttons">
            <slot name="buttons">
            </slot>
        </div>
        <slot></slot>
    </div>
</template>

<script type="text/javascript">

export default {
    components: {},
    props: {
        isActive: {
            type: Boolean,
            default: false
        },
        iconClass: {
            type: String,
            default: 'ogc-icon-fangkuaizuhe'
        },
        title: {
            type: String,
            required: true
        },
        subTitle: {
            type: String,
            required: true
        },
    },
    data() {
        return {}
    },
    methods: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {}
}
</script>

<style type="text/css" scoped>

.item {
    float: left;
    overflow: hidden;
    width: calc(50% - 20px);
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #AAA;
}

.item:nth-child(2n) {
    float: right;
}

.item > .item-icon {
    float: left;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
}

.item > .item-icon > .ogc-icon-font{
    color: #AAA;
    font-size: 36px;
}

.item.active > .item-icon > .ogc-icon-font{
    color: #00B1FF;
}
.item > .item-info {
    float: left;
    padding: 5px;
}
.item > .item-info > p {
    line-height: 20px;
}
.item > .item-info > p.strong {
    font-weight: 700;
}
.item > .buttons {
    float: right;
    line-height: 50px;
}

</style>



// WEBPACK FOOTER //
// src/views/Me/Info/components/OptionItem.vue